import { useEffect } from 'react';

export const useReportEmptyState = (
  isEmpty: boolean,
  onEmptyStateChange: (isEmpty: boolean) => void
) => {
  useEffect(() => {
    onEmptyStateChange(isEmpty);
  }, [isEmpty, onEmptyStateChange]);
};
